export const userLabel = (user, emptyValue = '-') => {
  if (!user) return emptyValue;
  const fullName = [user.name, user.surname].filter(Boolean).join(' ').trim();
  if (fullName) return fullName;
  return user.email ?? emptyValue;
};
